import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {computed} from  'mobx';
import AccordionItemHeader from './accordion-item-header';
import AccordionItemBody from './accordion-item-body';

@observer
export default class AccordionItem extends React.Component {

  static propTypes = {
    itemTitle: PropTypes.string.isRequired,
    handleSectionToggle: PropTypes.func.isRequired,
    sectionId: PropTypes.number.isRequired,
    itemArray: PropTypes.array,
    accordionStore: PropTypes.object.isRequired,
    isInEditMode: PropTypes.bool,
    sectionType: PropTypes.string
  }

  static defaultProps = {
    itemTitle: '',
    itemArray: []
  }
  

  handleToggle = () => {
    this.props.handleSectionToggle(this.props.itemTitle);
  }

  @computed get isExpanded() {
    
    return (this.props.accordionStore.expandedSections.indexOf(this.props.itemTitle) > -1);
  }

  render() {
    
    return (
      <article className="row no-gutters accordion">
        <div className="col-12">
          <div className="accordion__item">
            <AccordionItemHeader
              title={this.props.itemTitle}
              numberOfItems={this.props.itemArray.length}
              isExpanded={this.isExpanded}
              itemArray={this.props.itemArray}
              toggleAction={this.handleToggle} />
            <AccordionItemBody
              itemArray={this.props.itemArray}
              isExpanded={this.isExpanded}
              sectionId={this.props.sectionId}
              isInEditMode={this.props.isInEditMode}
              sectionType={this.props.sectionType}
               />
          </div>
        </div>
      </article>
    )
  }
}
